import { useState } from 'react'

import { SortDirection } from '@/graphql'

export const useTableOrder = <T>(
  initialOrderBy: keyof T,
  initialOrder: SortDirection = SortDirection.DESC,
) => {
  const [order, setOrder] = useState<SortDirection>(initialOrder)
  const [orderBy, setOrderBy] = useState<keyof T>(initialOrderBy)
  const handleRequestSort = (property: keyof T) => {
    const isAsc = orderBy === property && order === 'ASC'
    setOrder(isAsc ? SortDirection.DESC : SortDirection.ASC)
    setOrderBy(property)
  }

  return {
    order,
    orderBy,
    handleRequestSort,
    setOrder,
    setOrderBy,
  }
}
